import { type ChangeEvent, useCallback, useMemo } from 'react';
import { debounce } from 'utils/debounce';
import { CustomFieldTextInput } from './CustomFieldTextInput';
import type { EditableFieldSharedProps } from './types';
import { updateVariableValue } from 'components/editor/grid/reduxStore/allVariableSlice';

export function EditableTextCustomFieldInput({ field, mutate, dispatch, currentValue, fieldTypeOption, t }: EditableFieldSharedProps) {
  const debouncedMutate = useMemo(() => debounce(mutate, 500), [mutate]);

  const handleChange = useCallback(
    (e: ChangeEvent<HTMLTextAreaElement | HTMLInputElement>) => {
      const newValue = e.target.value;
      if (newValue && newValue.length > 100) return;
      dispatch(updateVariableValue({ variableName: field.name, newValue }));
      debouncedMutate({ id: field.id, type: field.type, value: newValue === '' ? null : newValue });
    },
    [dispatch, field, debouncedMutate]
  );

  return (
    <CustomFieldTextInput
      field={field}
      placeholder={field.placeholder || t(fieldTypeOption.defaultPlaceholderKey)}
      value={currentValue}
      onChange={handleChange}
    />
  );
}
